import { render } from "./ListaSinistrosAcordoParcelasView.vue?vue&type=template&id=29051606&scoped=true"
import script from "./ListaSinistrosAcordoParcelasView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosAcordoParcelasView.vue?vue&type=script&lang=js"

import "./ListaSinistrosAcordoParcelasView.vue?vue&type=style&index=0&id=29051606&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29051606"]])

export default __exports__